import React from "react";
import BrowserHeaderMockup from './BrowserHeaderContent'
import BrowserTopBarMockup from './BrowserNavigationBar'
import { Box } from "@chakra-ui/core";

function ScreenMockup({perspective = "left", section, size = "1080px", children}) {
  return (
    <Box
      bg="primary.transparent-600"
      borderRadius="10px"
      m="auto"
      my="30px"
      w="90%"
      pb="12px"
      minW="320px"
      maxW={size === "small" ? "500px" : "1080px"}
      minH="450px"
      boxShadow="-14px 57px 93px -53px rgba(0,0,0,0.75)"
      transform={perspective}
    >
      <BrowserTopBarMockup />
      <Box m="auto" my="16px" minW="300px" >
        <BrowserHeaderMockup title={section} />
        {children}
      </Box>
    </Box>
  );
}

export default ScreenMockup;
